import mixpanel from "mixpanel-browser";
import { setGTMUserId } from "./gtm";

let initialized = false;

export function initMixpanel(): void {
  const token = process.env.REACT_APP_MIXPANEL_TOKEN;
  if (typeof window === "undefined" || !token?.trim() || initialized) {
    return;
  }

  mixpanel.init(token.trim(), {
    autocapture: true,
    record_sessions_percent: 100,
  });
  mixpanel.register({
    product: "Creator Platform MVP",
    analytics_schema: "mvp_aarrr_v1",
  });
  initialized = true;
}

export function isMixpanelInitialized(): boolean {
  return initialized;
}

/** Зв’язує події з одним користувачем у Mixpanel (воронки / унікальність). */
export function identifyMixpanelUser(userId: string | null | undefined): void {
  setGTMUserId(userId);
  if (!initialized || !userId) {
    return;
  }
  mixpanel.identify(String(userId));
}

/**
 * Лінкує анонімний distinct_id до userId після signup (щоб ранні події не "губились").
 * Важливо: alias треба викликати ДО identify, і лише один раз на userId.
 */
export function aliasMixpanelUser(userId: string | null | undefined): void {
  if (!initialized || !userId) {
    return;
  }
  try {
    mixpanel.alias(String(userId));
  } catch {
    // alias може падати/ігноритися якщо вже існує — це ок
  }
}

export function setMixpanelPeopleProfile(props: {
  email?: string | null;
  name?: string | null;
}): void {
  if (!initialized) {
    return;
  }
  const email = props.email?.trim();
  const name = props.name?.trim();
  const payload: Record<string, string> = {};
  if (email) payload.$email = email;
  if (name) payload.$name = name;
  if (Object.keys(payload).length === 0) {
    return;
  }
  try {
    mixpanel.people?.set(payload);
  } catch {
    // people може бути недоступний у деяких конфігах — не блокуємо флоу
  }
}

/** Після лог-ауту, щоб наступний акаунт не «наслідував» профіль у Mixpanel. */
export function resetMixpanelIdentity(): void {
  setGTMUserId(null);
  if (!initialized) {
    return;
  }
  mixpanel.reset();
}

export { mixpanel };
